import {defer, merge, Observable, of} from "rxjs";
import {AbstractControl} from "@angular/forms";

export function controlValueChanges<T extends AbstractControl>(control: T): Observable<T["value"]> {
    return merge(
        defer(() => of(control.value)),
        control.valueChanges
    )
}
